module.exports = __webpack_public_path__ + "img/xiangjin3.c4d199a1.png";